module.exports = __webpack_public_path__ + "img/search.5ab0c2a9.svg";